'use client'

import { AppBar, Box, styled } from '@mui/material'
import { alpha } from '@mui/material/styles'

import { MegaMenu } from '@/components/MegaMenu/MegaMenu'
import { useHeaderContext } from '@/hooks/useHeaderContext'
import { useMedia } from '@/hooks/useMedia'

import type { FC, PropsWithChildren } from 'react'
import type { TopNavigationNode } from '@/interfaces/NavigationNode'

const HeaderAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.body,
  boxShadow: `${alpha(theme.palette.common.black, 0.1)} 0px 4px 5px`,
  overflowX: 'hidden',
}))

interface Props extends PropsWithChildren {
  navigation?: TopNavigationNode[]
  window?: () => Window
}

export const Header: FC<Props> = ({ navigation, children }) => {
  const { isSearchOpen, headerAppBarRef } = useHeaderContext()
  const { isMobile } = useMedia()

  return (
    <Box
      sx={{
        position: isSearchOpen ? 'fixed' : 'sticky',
        zIndex: (theme) => theme.zIndex.appBar,
        top: 0,
        width: '100%',
      }}
    >
      <HeaderAppBar position="sticky" sx={{ overflow: 'hidden' }} ref={headerAppBarRef}>
        {children}
      </HeaderAppBar>
      {!isMobile && navigation && <MegaMenu navigation={navigation} />}
    </Box>
  )
}
